import React from 'react';


const IconWrapper = (path, viewboxDefault = 16) => {
    return (
        <span className="bp4-icon">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0"
                 width={viewboxDefault} height={viewboxDefault}
                 fillRule={'evenodd'}
                 viewBox={`0 0 ${viewboxDefault} ${viewboxDefault}`}
            >
                {path}
            </svg>
        </span>
    );
};


const AddTagIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path fillRule={'evenodd'} d="M0,2.769l0,3.976c0,0.204 0.081,0.399 0.225,0.543l8.488,8.487c0.3,0.3 0.785,0.3 1.085,0l3.977,-3.976c0.3,-0.3 0.3,-0.786 0,-1.085l-8.488,-8.488c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767Zm3.554,1.757c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path fillRule={'evenodd'} d="M13.5,2.5l0,-2.5l-2,0l0,2.5l-2.5,0l0,2l2.5,0l0,2.5l2,0l0,-2.5l2.5,0l0,-2l-2.5,0Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path fillRule={'evenodd'} d="M0,3.461l0,4.971c0,0.254 0.101,0.498 0.281,0.678l10.611,10.609c0.374,0.375 0.981,0.375 1.356,0l4.971,-4.971c0.375,-0.374 0.375,-0.981 0,-1.356l-10.611,-10.609c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,0c-0.53,0 -0.959,0.429 -0.959,0.959Zm4.442,2.197c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
            <path fillRule={'evenodd'} d="M16.875,3.125l0,-3.125l-2.5,0l0,3.125l-3.125,0l0,2.5l3.125,0l0,3.125l2.5,0l0,-3.125l3.125,0l0,-2.5l-3.125,0Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const EditTagAttachmentsIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M4.571,10.897l4.632,-8.022l-2.595,-2.594c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,-0c-0.53,-0 -0.959,0.429 -0.959,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l4.29,4.289Zm-0.129,-7.741c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
        <path d="M3.54,16.767c-0,0.917 0.31,1.685 0.929,2.304c0.619,0.619 1.387,0.929 2.304,0.929c1.058,-0 1.979,-0.392 2.763,-1.176l9.135,-9.123c0.886,-0.902 1.329,-1.964 1.329,-3.186c-0,-1.247 -0.431,-2.305 -1.293,-3.175c-0.862,-0.87 -1.917,-1.305 -3.163,-1.305c-1.238,0 -2.308,0.443 -3.21,1.329l-7.113,7.124c-0.078,0.079 -0.117,0.165 -0.117,0.259c-0,0.126 0.119,0.308 0.358,0.547c0.239,0.239 0.422,0.358 0.547,0.358c0.102,0 0.192,-0.039 0.27,-0.117l7.125,-7.137c0.619,-0.603 1.329,-0.905 2.128,-0.905c0.831,-0 1.533,0.294 2.105,0.882c0.572,0.588 0.858,1.297 0.858,2.128c0,0.823 -0.298,1.532 -0.893,2.128l-9.124,9.135c-0.494,0.494 -1.062,0.741 -1.705,0.741c-0.501,-0 -0.917,-0.165 -1.246,-0.494c-0.329,-0.329 -0.494,-0.745 -0.494,-1.246c0,-0.643 0.247,-1.211 0.741,-1.705l6.831,-6.831c0.204,-0.188 0.439,-0.282 0.705,-0.282c0.227,-0 0.416,0.074 0.565,0.223c0.148,0.149 0.223,0.337 0.223,0.565c-0,0.25 -0.098,0.482 -0.294,0.693l-4.82,4.821c-0.079,0.078 -0.118,0.164 -0.118,0.258c-0,0.126 0.121,0.31 0.364,0.553c0.243,0.243 0.428,0.364 0.553,0.364c0.094,0 0.18,-0.039 0.259,-0.117l4.82,-4.821c0.494,-0.478 0.741,-1.062 0.741,-1.751c-0,-0.643 -0.224,-1.188 -0.67,-1.635c-0.447,-0.446 -0.992,-0.67 -1.635,-0.67c-0.689,0 -1.273,0.247 -1.751,0.741l-6.831,6.831c-0.784,0.768 -1.176,1.689 -1.176,2.763Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M3.932,8.993l3.706,-6.418l-2.351,-2.35c-0.144,-0.144 -0.339,-0.225 -0.543,-0.225l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767l0,3.977c0,0.203 0.081,0.398 0.225,0.542l3.707,3.707Zm-0.378,-6.468c-0,-0.565 -0.458,-1.023 -1.023,-1.023c-0.565,0 -1.023,0.458 -1.023,1.023c0,0.565 0.458,1.022 1.023,1.022c0.565,0 1.023,-0.457 1.023,-1.022Z"/>,
            <path d="M3.312,13.508c-0,0.707 0.238,1.299 0.716,1.776c0.477,0.477 1.069,0.716 1.776,0.716c0.816,0 1.526,-0.302 2.13,-0.906l7.042,-7.033c0.683,-0.695 1.024,-1.514 1.024,-2.456c0,-0.961 -0.332,-1.777 -0.997,-2.447c-0.665,-0.671 -1.477,-1.006 -2.438,-1.006c-0.955,-0 -1.779,0.341 -2.474,1.024l-5.483,5.492c-0.061,0.06 -0.091,0.127 -0.091,0.199c0,0.097 0.092,0.238 0.277,0.422c0.184,0.184 0.324,0.276 0.421,0.276c0.079,0 0.148,-0.03 0.208,-0.09l5.493,-5.502c0.477,-0.465 1.024,-0.698 1.64,-0.698c0.641,0 1.181,0.227 1.622,0.68c0.441,0.453 0.662,1 0.662,1.641c-0,0.634 -0.23,1.181 -0.689,1.64l-7.033,7.042c-0.38,0.381 -0.818,0.571 -1.314,0.571c-0.387,-0 -0.707,-0.127 -0.961,-0.381c-0.253,-0.253 -0.38,-0.574 -0.38,-0.96c-0,-0.496 0.19,-0.934 0.571,-1.314l5.265,-5.266c0.157,-0.145 0.339,-0.218 0.544,-0.218c0.175,0 0.32,0.058 0.435,0.173c0.115,0.114 0.172,0.259 0.172,0.435c0,0.193 -0.075,0.371 -0.226,0.534l-3.716,3.716c-0.06,0.061 -0.091,0.127 -0.091,0.2c0,0.096 0.094,0.238 0.281,0.426c0.188,0.187 0.33,0.28 0.426,0.28c0.073,0 0.139,-0.03 0.2,-0.09l3.715,-3.716c0.381,-0.369 0.571,-0.819 0.571,-1.35c0,-0.496 -0.172,-0.916 -0.516,-1.26c-0.345,-0.345 -0.764,-0.517 -1.26,-0.517c-0.532,0 -0.982,0.191 -1.35,0.571l-5.266,5.266c-0.604,0.592 -0.906,1.302 -0.906,2.13Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const EditTagIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path fillRule={'evenodd'} d="M3.932,10.995l3.706,-6.418l-2.351,-2.351c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767l0,3.976c0,0.204 0.081,0.399 0.225,0.543l3.707,3.707Zm-0.378,-6.469c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path fillRule={'evenodd'} d="M16,2.5l-4.33,-2.5l-5.846,10.125l0.217,4.625l4.113,-2.125l5.846,-10.125Zm-1.353,0.344l-0.866,-0.5l-5.359,9.281l0.866,0.5l5.359,-9.281Zm-1.732,-1l-0.866,-0.5l-5.359,9.281l0.866,0.5l5.359,-9.281Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path fillRule={'evenodd'} d="M4.571,13.399l4.632,-8.022l-2.595,-2.594c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,0c-0.53,0 -0.959,0.429 -0.959,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l4.29,4.289Zm-0.129,-7.741c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
            <path fillRule={'evenodd'} d="M20,3.5l-6.062,-3.5l-6.669,11.55l0.174,6.7l5.889,-3.2l6.668,-11.55Zm-4.3,-1.125l-1.099,-0.65l-5.992,10.325l1.099,0.65l5.992,-10.325Zm2.484,1.45l-1.099,-0.65l-5.992,10.325l1.099,0.65l5.992,-10.325Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const DeleteTagIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M0,0.769l0,3.976c0,0.204 0.081,0.399 0.225,0.543l1.488,1.488l5.062,-5.061l-1.488,-1.489c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767Zm3.554,1.757c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path d="M9.636,6.808l-3.535,-3.536l-2.829,2.829l3.536,3.535l-3.536,3.536l2.829,2.828l3.535,-3.536l3.536,3.536l2.828,-2.828l-3.536,-3.536l3.536,-3.535l-2.828,-2.829l-3.536,3.536Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M0,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l3.611,3.609l6.327,-6.327l-3.611,-3.609c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,0c-0.53,0 -0.959,0.429 -0.959,0.959Zm4.442,2.197c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
            <path d="M13.064,10.205l-3.788,-3.788l-2.909,2.909l3.788,3.788l-3.636,3.637l3.03,3.03l3.637,-3.636l3.788,3.788l2.909,-2.909l-3.788,-3.788l3.636,-3.637l-3.03,-3.03l-3.637,3.636Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const ListTagsIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M6,11.062l0,-8.062l2.061,0l-2.774,-2.774c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767l0,3.976c0,0.204 0.081,0.399 0.225,0.543l5.775,5.774Zm-2.446,-8.536c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path d="M16,4l-9,0l0,12l9,0l0,-12Zm-1,1l-7,0l0,10l7,0l0,-10Z"/>,
        <rect x="9" y="6" width="5" height="1.5"/>,
        <rect x="9" y="9.3" width="3" height="1.5"/>,
        <rect x="9" y="12.5" width="5" height="1.5"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M20,4l-11,0l0,16l11,0l0,-16Zm-1.5,1.5l-8,0l0,13l8,0l0,-13Z"/>,
            <rect x="12" y="7" width="5" height="2"/>,
            <rect x="12" y="11" width="3" height="2"/>,
            <rect x="12" y="15" width="5" height="2"/>,
            <path d="M8,14.326l-0,-11.326l1.328,-0l-2.72,-2.719c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,-0c-0.53,-0 -0.959,0.429 -0.959,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l7.719,7.718Zm-3.558,-11.17c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const TagsLegendIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M2,1l2,2l-2,2l-2,-2l2,-2Z"/>,
        <circle cx="2" cy="8" r="2"/>,
        <path d="M2,11l2,4l-4,0l2,-4Z"/>,
        <rect x="6" y="2" width="10" height="2"/>,
        <rect x="6" y="7" width="10" height="2"/>,
        <rect x="6" y="12" width="10" height="2"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M3,0l3,3l-3,3l-3,-3l3,-3Z"/>,
            <circle cx="3" cy="10" r="3"/>,
            <path d="M3,14l3,6l-6,0l3,-6Z"/>,
            <rect x="8" y="1.5" width="12" height="3"/>,
            <rect x="8" y="8.5" width="12" height="3"/>,
            <rect x="8" y="15" width="12" height="3"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


export {
    AddTagIcon,
    EditTagIcon,
    DeleteTagIcon,
    ListTagsIcon,
    TagsLegendIcon,
    EditTagAttachmentsIcon
}